import { render, staticRenderFns } from "./BonusMilesBadge.vue?vue&type=template&id=12c988b8&scoped=true&"
import script from "./BonusMilesBadge.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BonusMilesBadge.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BonusMilesBadge.vue?vue&type=style&index=0&id=12c988b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c988b8",
  null
  
)

export default component.exports